import WidgetMarketingModal from './WidgetMarketingModal';

export default WidgetMarketingModal;
